<template>
  <v-card height="100%" class="fill-height justify-center text-center" color="orange lighten-3" elevation="0">
    <v-card-title class="text-h5 white--text"> Brew Progress
    <!-- <span class="text-h5 white--text">Brew</span> -->
    <v-spacer></v-spacer>
    <v-btn @click="gohome" icon><v-icon large>home</v-icon></v-btn>  
  </v-card-title>
  <hr style="height:2px; width:90%; border-width:0; color:yellow; margin:5%; margin-top:0%; background-color:yellow">
  <v-card-text>

    <v-row>
      <v-col>
        <v-text-field
        v-model="currentstage"
        readonly
        outlined
        dense
        label="Current Stage"
        class="mt-0 align-center"
        ></v-text-field>
          <template v-slot:append-outer>
            <v-chip v-model="status" color="success">Running</v-chip>
          </template>
      </v-col>
      <v-col>
        <v-chip v-model="status" color="success">Running</v-chip>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
          outlined
          v-model="statusnotes"
          name="input-5-1"
          label="Status Notes"
          auto-grow
          readonly
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
        v-model="currenttemp"
        readonly
        outlined
        dense
        label="Temperature"
        class="mt-0"
        suffix="°C"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model="targettemp"
          readonly
          outlined
          dense
          label="Target Temp"
          class="mt-0"
          suffix="°C"
        ></v-text-field>
      </v-col>
    </v-row>
        <v-row>
      <v-col>
        <v-text-field
        v-model="timeremaining"
        readonly
        outlined
        dense
        label="Time Remaining"
        class="mt-0"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model="flowrate"
          readonly
          outlined
          dense
          label="Flow Rate"
          class="mt-0"
          suffix="mL/m"
        ></v-text-field>
      </v-col>
    </v-row>
     <v-row align="center" justify="space-around">
      <v-col>
        <v-btn @click="pause">Pause</v-btn>
      </v-col>
      <v-col>
        <v-btn @click="cancel">Cancel</v-btn>
      </v-col>
    </v-row>
    


  </v-card-text>



</template>

<script>

export default {
  data () {
    return {
      currentstage: '',
      status: '',
      statusnotes: '',
      currenttemp: 0,
      targettemp: 0,
      timereamining: 0,
      flowrate: 0

    }
  },

  methods: {
    gohome () {
      this.$router.push('/')
    },
    pause () {

    },
    cancel () {

    }
  }
}

</script>
